import Button from 'components/Button'
import Modal from 'components/Modal'
import TimeAgo from 'components/TimeAgo'
import { routes } from 'constants/routes'
import { ModalInjectedProps } from 'containers/ModalManager'
import { useToast } from 'containers/ToastManager'
import { useVersionDelete } from 'modules/versioning/operations'
import React from 'react'
import { useHistory } from 'react-router-dom'

export interface DeleteVersionModalProps extends ModalInjectedProps {
  shareName: string
  creatorName: string
  createdAt: string
  versionIdentifier: string
  shareID: string
  isActive: boolean
}

export const DeleteVersionModal: React.FC<DeleteVersionModalProps> = props => {
  const {
    shareName,
    hideModal,
    versionIdentifier,
    shareID,
    isActive,
    createdAt,
    creatorName,
  } = props
  const { showToast } = useToast()
  const history = useHistory()

  const [deleteVersion, { loading }] = useVersionDelete({
    versionIdentifier,
    shareIdentifier: shareID,
    onError: message => {
      showToast(message, 'negative')
    },
    onCompleted: () => {
      showToast(`The update of "${shareName}" has been deleted`)

      // redirect to share overview
      if (isActive) {
        history.push(routes.SHARE_VIEW.create({ shareID }))
      }

      hideModal()
    },
  })

  return (
    <Modal title="Delete Document Update?" onCancel={hideModal}>
      <Modal.Body>
        <p>
          {creatorName} uploaded the &ldquo;{shareName}&rdquo; update{' '}
          <TimeAgo date={createdAt} />. This action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} onClick={hideModal}>
          Cancel
        </Button>
        <Button
          variant="negative"
          loading={loading}
          disabled={loading}
          onClick={() => deleteVersion()}>
          Delete Update
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
